export const ATTRIBUTE_MODELS = [
  {
    id: 0,
    option: 'Conversation',
  },
  {
    id: 1,
    option: 'Contact',
  },
  {
    id: 2,
    option: 'Agent',
  },
];

export const ATTRIBUTE_TYPES = [
  {
    id: 0,
    option: 'Text',
  },
  {
    id: 1,
    option: 'Number',
  },
  {
    id: 4,
    option: 'Link',
  },
  {
    id: 5,
    option: 'Date',
  },
  {
    id: 6,
    option: 'List',
  },
  {
    id: 7,
    option: 'Checkbox',
  },
];
